// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-MY', {
    style: 'currency',
    currency: 'MYR',
    minimumFractionDigits: 2,
  }).format(amount);
};

// Format number with commas
export const formatNumber = (num) => {
  return new Intl.NumberFormat('en-MY').format(num);
};

// Format date
export const formatDate = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
};

// Format datetime
export const formatDateTime = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

// Get tier color
export const getTierColor = (tier) => {
  const tierColors = {
    bronze: { bg: 'bg-[#F4E4D7]', text: 'text-[#CD7F32]', border: 'border-[#CD7F32]/20' },
    silver: { bg: 'bg-[#F0F0F0]', text: 'text-[#808080]', border: 'border-[#C0C0C0]/20' },
    gold: { bg: 'bg-[#FFF9E6]', text: 'text-[#B8860B]', border: 'border-[#FFD700]/20' },
    elite: { bg: 'bg-[#F3E8FF]', text: 'text-[#9333EA]', border: 'border-[#9333EA]/20' },
  };
  return tierColors[tier] || tierColors.bronze;
};

// Get status badge color
export const getStatusColor = (status) => {
  const statusColors = {
    active: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    completed: 'bg-blue-100 text-blue-800',
    rejected: 'bg-red-100 text-red-800',
    expired: 'bg-gray-100 text-gray-800',
    qualified: 'bg-blue-100 text-blue-800',
    paid: 'bg-green-100 text-green-800',
    fraud_flagged: 'bg-red-100 text-red-800',
    approved: 'bg-green-100 text-green-800',
    cancelled: 'bg-gray-100 text-gray-800',
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800';
};

// Calculate percentage
export const calculatePercentage = (value, total) => {
  if (total === 0) return 0;
  return Math.round((value / total) * 100);
};